<template>
  <base-modal modal-id="top-up-payment">
    <template v-slot:header>
      <button
        type="button"
        class="btn btn-arrow"
        data-toggle="modal"
        data-dismiss="modal"
        @click="proceedBack"
      >
        <img src="/images/svg/global/left_arrow.svg" alt="" />
      </button>
      <h4 class="modal-title mb-0 ">{{ _T('Payment Method') }}</h4>
    </template>
    <template v-slot:modal-body>
      <form class="default-form">
        <div class="form-group">
          <label>{{ _T('Saved credit card') }}</label>
          <ul>
            <li>
              <label for="edo-ani20">
                <input
                  class="radio_animated"
                  id="edo-ani20"
                  type="radio"
                  name="rdo-ani3"
                  checked=""
                />
                <div class="media">
                  <div class="media-body">
                    <h6>{{ _T('XXXX-XXXX-XXXX-9862') }}</h6>
                    <h6>{{ _T('09/19') }}</h6>
                  </div>
                  <img
                    src="/images//checkout/master-card-square.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </label>
            </li>
            <li>
              <label for="edo-ani21">
                <input
                  class="radio_animated"
                  id="edo-ani21"
                  type="radio"
                  name="rdo-ani3"
                />
                <div class="media">
                  <div class="media-body">
                    <h6>{{ _T('XXXX-XXXX-XXXX-9862') }}</h6>
                    <h6>{{ _T('09/19') }}</h6>
                  </div>
                  <img
                    src="/images//checkout/master-card-square.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </label>
            </li>
            <li>
              <label for="edo-ani22">
                <input
                  class="radio_animated"
                  id="edo-ani22"
                  type="radio"
                  name="rdo-ani3"
                />
                <div class="media">
                  <div class="media-body">
                    <h6>{{ _T('XXXX-XXXX-XXXX-9862') }}</h6>
                    <h6>{{ _T('09/19') }}</h6>
                  </div>
                  <img
                    src="/images//checkout/master-card-square.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </label>
            </li>
          </ul>
          <div class="add-new">
            <a href="#" @click="$bvModal.show('addCard')">
              <img src="/images/svg/checkout/card-r.svg" alt="" />
              <span>{{ _T('+ Add another card') }}</span>
            </a>
          </div>
        </div>
        <button
          type="button"
          class="btn btn-solid btn-block"
          data-dismiss="modal"
        >
          {{ _T('Pay Now') }}
        </button>
      </form>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '../BaseModal'
import { mapGetters } from 'vuex'
export default {
  name: 'TopUpPayment',
  components: {
    BaseModal,
  },
  computed: {
    ...mapGetters(['_T']),
  },
  methods: {
    proceedBack() {
      this.$bvModal.hide('top-up-payment')
      this.$bvModal.show('top-up')
    },
  },
}
</script>

<style lang="scss" scoped>
ul {
  padding-bottom: $px30;
  border-bottom: $px1 solid $light-border;

  li {
    display: block;
    position: relative;

    + li {
      margin-top: $px16;
    }

    label {
      display: block;
      padding-left: $px40;
      margin-bottom: 0 !important;

      .radio_animated {
        &:after {
          border: $px1 solid $dark-border;
        }

        &:checked {
          &:after {
            border: $px1 solid $color-primary;
          }
        }
      }

      input {
        position: absolute;
        left: $px2;
        top: $px32;
      }

      .media {
        padding: $px16;
        border: $px1 solid $dark-border;
        border-radius: $px4;

        .media-body {
          h6 {
            font-weight: 600;
            font-size: 13.5px;
            line-height: $px21;
            color: $font-color;
            margin-bottom: 0;

            + h6 {
              color: $light-font;
            }
          }
        }
      }
    }
  }
}

.add-new {
  padding-top: $px20;

  a {
    span {
      vertical-align: middle;
      font-weight: 600;
      font-size: $px15;
      line-height: $px18;
      letter-spacing: -0.533334px;
    }
  }
}
</style>
